import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// export const sendToReactNative = (data: any) => {
//   if (!window.ReactNativeWebView) return;

//   window.ReactNativeWebView.postMessage(JSON.stringify({ data }));
// };

export const getFormattedTimestamp = () => {
  const now = new Date();
  return now
    .toLocaleString('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
    .replace(/[/:]/g, '-')
    .replace(/, /g, '_'); // e.g. 06-06-2025_18-25
};
